import { Asset } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useQuery } from '@tanstack/react-query';

export const GET_ASSET_TEXT_QUERY_KEY = 'assets.getAssetText';

export const useGetAssetText = ({ asset }: { asset: Asset }) => {
  const { data, error } = useQuery({
    queryKey: [GET_ASSET_TEXT_QUERY_KEY, { assetId: asset.id, tenantId: asset.tenantId }],
    queryFn: () => api.assets.assetDownload(asset.tenantId, asset.id, { format: 'text' }),
  });

  return {
    text: data?.data,
    error,
  };
};
